import { type RawMessagePanelState } from "@/shared/state/visualization";

import { type PanelSettingsSidebarProps } from "../../sidebarContext";
import { BasePanelSettings } from "../BasePanelSettings";
import { SettingsSection } from "../SettingsSection";
import { Spotlight } from "../Spotlight";

import { AddMessagePath } from "./AddMessagePath";
import { MessagePaths } from "./MessagePaths";

export interface RawMessagePanelSettingsSidebarProps extends PanelSettingsSidebarProps {
  field?: "MessagePaths";
}

export interface RawMessagePanelSettingsProps extends RawMessagePanelSettingsSidebarProps {
  state: RawMessagePanelState;
}

export function RawMessagePanelSettings({
  field,
  spotlightKey,
  state,
}: RawMessagePanelSettingsProps) {
  return (
    <BasePanelSettings state={state}>
      <SettingsSection title="Message Paths">
        <MessagePaths panelId={state.id} messagePaths={state.data} />
        <Spotlight
          spotlightKey={field === "MessagePaths" ? spotlightKey : undefined}
        >
          <AddMessagePath state={state} />
        </Spotlight>
      </SettingsSection>
    </BasePanelSettings>
  );
}
